import React, { useState } from 'react';
import axios from 'axios';
import Popup from 'reactjs-popup';
import { useNavigate } from 'react-router-dom';

const ModalModifyAnnuaireAltaClient = ({ isVisible, onClose, choosenAnnuaireAlta }) => {
    let token = localStorage.getItem("token");
    const navigate = useNavigate();

    const [values, setValues] = useState({
        id_client:'',
        nom_client:'',
        email: '', 
        date:'',
        password:''
    })

    const handleClose = (e) => {  if(e.target.id === "wrapper") onClose(); }
    
    if (choosenAnnuaireAlta.id_client !== values.id_client) setValues({ ...values, ...choosenAnnuaireAlta })

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    
    const deleteClient = (e) => {
        e.preventDefault();
        let data = {
            id_client: values.id_client
        }
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_client_annuaire_alta`,{headers, data})
            .then((res) => {
                navigate('/annuairealtaclient');
            }).catch(err => console.log(err))
        
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        values.date = new Date(values.date).toLocaleDateString("fr").split("/").reverse().join("-")

        
        axios.put(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/update_client_annuaire_alta`, values, {headers})
        .then(res => {
            window.location.reload(false);
        }).catch(err => console.log(err))
    }

    function formatDateClient(datePose) {
        let newdate = new Date(datePose)
        // let month = newdate.getMonth()+1
        let month = newdate.getMonth() + 1 > 9 ? newdate.getMonth() + 1 : `0${newdate.getMonth() + 1}`
        let day = newdate.getDate() > 9 ? newdate.getDate() : `0${newdate.getDate()}`
        let formatDate = `${newdate.getFullYear()}-${month}-${day}`
        return formatDate;
    }
    
    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }

    if( !isVisible ) return null;

    return (
        <div className='fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center' id="wrapper" onClick={handleClose}>
            <div className='w-[92vw] max-w-[600px] flex flex-col'>
                <button className='text-white text-xl place-self-end' onClick={() => onClose()}>X</button>
                <form className="bg-slate-700 p-6 rounded-3xl" onSubmit={handleSubmit}>
                    <div className="relative z-0 w-full mb-6 group">
                        <input type="text" name="nom_client" id="nom_client" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" "   onChange={e => setValues({...values, nom_client: e.target.value})} value={values.nom_client} />
                        <label htmlFor="nom_client" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Nom Client:</label>
                    </div>
                    <div className="relative z-0 w-full mb-6 group">
                        <input type="date" name="date" id="date" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" "   onChange={e => setValues({...values, date: e.target.value})} value={formatDateClient(values.date)} />
                        <label htmlFor="date" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Date:</label>
                    </div>
                    <div className="relative z-0 w-full mb-6 group">
                        <input type="text" name="email" id="email" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" "   onChange={e => setValues({...values, email: e.target.value})} value={values.email} />
                        <label htmlFor="email" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Email:</label>
                    </div>
                    <div className="relative z-0 w-full mb-6 group">
                        <input type="text" name="password" id="password" className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-slate-50 appearance-none dark:text-white dark:border-slate-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" "   onChange={e => setValues({...values, password: e.target.value})} value={values.password} />
                        <label htmlFor="password" className="peer-focus:font-medium absolute text-sm text-slate-50 dark:text-white duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Password:</label>
                    </div>
                    <div className='flex justify-between'>
                        <Popup trigger=
                            {<button type="button" className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-blue-800" > Supprimer </button>}
                            position="right center">
                            <div>Est-ce votre dernier mot?</div>
                            <div className="flex justify-between">
                                <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-2 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={deleteClient}> Accepter </button>
                                <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-2 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                        <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalModifyAnnuaireAltaClient;